import almas_policy from "../pages/policy/almas_policy";

const PrivacyPolicy = () => {
    const site = process.env.REACT_APP_CLIENT_NAME;
    let policy;
    switch (site) {
        case "almas":
            policy = almas_policy;
            break;
        default:
            policy = "Terms and conditions not available";
    }
    return (
        <p dangerouslySetInnerHTML={{__html:policy}}>

        </p>
    )
}
export default PrivacyPolicy;